import { TaxSectionProps } from ".";
import { InputButton } from "../../components/Forms/InputButton";
import { Text } from "../../components/Forms/InputButton/styles";
import { PixConfig } from "../../models/Rates";
import { ArrowIcon } from "../../styles/icons/ArrowIcon";
import { PixIcon } from "../../styles/icons/PixIcon";
import { Rewind } from "../../styles/icons/Rewind";
import { clearMask, formatCurrency, formatCurrencyToApiNoThrow } from "../../utils";
import { formatPaymentRangeFromApi, formatPaymentRangeToApi } from "../../utils/formatPaymentRangeToApi";
import { formatPercentageToNumber } from "../../utils/formatPercentageToNumber";
import { Divider, Header, Section } from "./styles";

interface PixSectionProps extends TaxSectionProps {
  pixConfigData: PixConfig;
  defaultPixConfigData: PixConfig;
  asModalView?: boolean;
}

export function PixSection({
  editionMode = false,
  pixConfigData,
  asModalView,
  defaultPixConfigData,
  register,
  errors,
  watch,
  setValue,
  colorFinder,
}: PixSectionProps) {
  function handleSetDefaultValue(name: string, defaultValue: string, func: any) {
    const convertionFunction = {
      "range": formatPaymentRangeFromApi,
      "percentage": (value) => formatPercentageToNumber(value),
      "currency": (value) => formatCurrency({ value })
    }
    setValue(name, convertionFunction[func](defaultPixConfigData[defaultValue]))
  }
  const delayForRedeem = formatTextView("pixDelayForRedeem", "delayForRedeem", formatPaymentRangeFromApi);
  const rate = formatTextView("pixRate", "rate",formatPercentageToNumber);
  const rateLimitValue = formatTextView("pixRateLimitValue", "rateLimitValue",formatCurrency, true);
  function formatTextView(auxName: string, innerValue: string, formater: (param: any) => any, formaterAsCurrency?: boolean): JSX.Element {
    const defaultValueFormatted = formaterAsCurrency ? formater({value: defaultPixConfigData[innerValue]}) : formater(defaultPixConfigData[innerValue]);
    const pastValue = formaterAsCurrency ? formater({value: pixConfigData[innerValue]}) : formater(pixConfigData[innerValue]);
    const laterValue = watch(auxName);
    if (clearMask(pastValue) === clearMask(laterValue)) {
      return (
        <Text fontSize=".9rem" color="var(--gray-200)">
          {laterValue}
        </Text>
      );
    } else {
      return (
        <Section gap=".4rem" align="center">
          <Text fontSize=".9rem" color={colorFinder(pastValue, defaultValueFormatted)}>
            {pastValue}
          </Text>
          <ArrowIcon size={13}/>
          <Text fontSize=".9rem" color={colorFinder(laterValue, defaultValueFormatted)}>
            {laterValue}
          </Text>
        </Section>
      );
    }
  }
  return (
    <>
      {pixConfigData && (
        <Section flexDir="column">
          <Section gap=".4rem" margin={asModalView ? "1rem 0 0" : ""}>
            <PixIcon />
            <Header>PIX</Header>
          </Section>
          {!asModalView && (
            <Section>
              <InputButton
                type="text"
                label="Tempo de repasse"
                tooltipButtonText="Redefinir para o valor padão"
                bgColor="#EDF1F7"
                variant="ghost"
                h="27px"
                width={asModalView ? "120px" : ""}
                mask="paymentRange"
                name="pixDelayForRedeem"
                register={{ ...register("pixDelayForRedeem") }}
                defaultValue={formatPaymentRangeFromApi(watch("pixDelayForRedeem"))}
                disabled={!editionMode}
                buttonFunction={() => handleSetDefaultValue("pixDelayForRedeem", "delayForRedeem", "range")}
                color={() => colorFinder(formatPaymentRangeToApi(watch("pixDelayForRedeem")), defaultPixConfigData?.delayForRedeem)}
                buttonDisabled={formatPaymentRangeToApi(watch("pixDelayForRedeem")) === defaultPixConfigData?.delayForRedeem}
                icon={<Rewind color={formatPaymentRangeToApi(watch("pixDelayForRedeem")) === defaultPixConfigData?.delayForRedeem ? "#00000040" : "black"} />}
                errors={errors?.pixDelayForRedeem}
              />
              <InputButton
                maxLength={4}
                label="Taxa"
                tooltipButtonText="Redefinir para o valor padão"
                bgColor="#EDF1F7"
                variant="ghost"
                h="27px"
                width={asModalView ? "120px" : ""}
                defaultValue={watch("pixRate")}
                mask="percentageRacional"
                name="pixRate"
                register={{ ...register("pixRate") }}
                disabled={!editionMode}
                buttonFunction={() => handleSetDefaultValue("pixRate", "rate", "percentage")}
                color={() => colorFinder(formatPercentageToNumber(watch("pixRate"), true), defaultPixConfigData?.rate)}
                buttonDisabled={formatPercentageToNumber(watch("pixRate"), true) === defaultPixConfigData?.rate}
                icon={<Rewind color={formatPercentageToNumber(watch("pixRate"), true) === defaultPixConfigData?.rate ? "#00000040" : "black"} />}
                errors={errors?.pixRate}
              />
              <InputButton
                label="Limite de taxas"
                tooltipButtonText="Redefinir para o valor padão"
                bgColor="#EDF1F7"
                variant="ghost"
                h="27px"
                width={asModalView ? "120px" : ""}
                mask="currencyE"
                defaultValue={watch("pixRateLimitValue")}
                name="pixRateLimitValue"
                register={{ ...register("pixRateLimitValue") }}
                disabled={!editionMode}
                buttonFunction={() => handleSetDefaultValue("pixRateLimitValue", "rateLimitValue", "currency")}
                color={() => colorFinder(formatCurrencyToApiNoThrow(watch("pixRateLimitValue")), defaultPixConfigData?.rateLimitValue)}
                buttonDisabled={formatCurrencyToApiNoThrow(watch("pixRateLimitValue")) === defaultPixConfigData?.rateLimitValue}
                icon={<Rewind color={formatCurrencyToApiNoThrow(watch("pixRateLimitValue")) === defaultPixConfigData?.rateLimitValue ? "#00000040" : "black"} />}
                errors={errors?.pixRateLimitValue}
              />
            </Section>
          )}
          {asModalView && (
            <Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Tempo de repasse
                </Text>
                {delayForRedeem}
              </Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Taxa
                </Text>
                {rate}
              </Section>
              <Section flexDir="column" gap=".1rem">
                <Text fontSize=".8rem" color="var(--gray-400)">
                  Limite de taxas
                </Text>
                {rateLimitValue}
              </Section>
            </Section>
          )}
          <Divider />
        </Section>
      )}
    </>
  )
}